// src/main.tsx
import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { initSentry } from "./lib/sentry";
import { ErrorBoundary } from "./components/ErrorBoundary";
import App from "./App.tsx";

import "./App.css";
import "./index.css";

// Initialize Sentry error monitoring (before anything else)
initSentry();

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string | undefined;

// Only initialize PostHog if user has accepted cookie consent (GDPR compliance)
const consent = typeof window !== "undefined" ? localStorage.getItem("cookie_consent") : null;
if (posthogKey && consent === "accepted") {
  posthog.init(posthogKey, {
    api_host: posthogHost || "https://us.i.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
  });
}

const rootEl = document.getElementById("root");

if (!rootEl) {
  document.body.innerHTML =
    "<div style='padding:24px;font-family:monospace;color:#b91c1c'>Missing #root element</div>";
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <ErrorBoundary>
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
